import { render, staticRenderFns } from "./DeletePetDialog.vue?vue&type=template&id=5e802057&scoped=true&"
import script from "./DeletePetDialog.vue?vue&type=script&lang=js&"
export * from "./DeletePetDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeletePetDialog.vue?vue&type=style&index=0&id=5e802057&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e802057",
  null
  
)

export default component.exports